import { Navigate } from "react-router";
import { useFeatures } from "@/hooks/useFeatures";

export function HomeRedirect() {
  const { firstAccessibleRoute } = useFeatures();
  return <Navigate to={firstAccessibleRoute} replace />;
}
